export const SocialLinks = [
  { href: "https://www.linkedin.com/in/shaimahamila/", iconClass: "uil uil-linkedin-alt" },
  { href: "https://github.com/shaimaHamila", iconClass: "uil uil-github-alt" },
  { href: "https://dribbble.com/shaimahamila", iconClass: "uil uil-dribbble" },
  { href: "https://www.facebook.com/shaimahamila", iconClass: "uil uil-facebook-f" },
  { href: "https://www.instagram.com/shaimahamila/", iconClass: "uil uil-instagram" },
];
export const Services = [
  {
    iconClass: "uil uil-brackets-curly",
    title: "Full-Stack Web Apps",
    description: "I build complete, responsive web applications from the ground up tailored to your business needs.",
    buttonText: "View Projects",
    buttonLink: "#projects",
  },
  {
    iconClass: "uil uil-server",
    title: "API & Backend Architecture",
    description: "I design scalable REST APIs, database schemas, and robust backend microservices.",
    buttonText: "View Projects",
    buttonLink: "#projects",
  },
  {
    iconClass: "uil uil-dashboard",
    title: "Admin Dashboards & Internal Tools",
    description: "I develop data-rich, secure dashboards to help manage your business operations and insights.",
    buttonText: "View Projects",
    buttonLink: "#projects",
  },
  {
    iconClass: "uil uil-brush-alt",
    title: "UX/UI Design in Figma",
    description: "I design seamless user experiences and modern interfaces with a focus on conversion and usability.",
    buttonText: "View My Dribbble",
    buttonLink: "https://dribbble.com/shaimaHamila",
  },
];
export const SkillsData = [
  { iconClass: "devicon-react-original colored", name: "React Ts", category: "Frontend" },
  { iconClass: "devicon-angularjs-plain colored", name: "Angular", category: "Frontend" },
  { iconClass: "devicon-redux-original colored", name: "Redux Toolkit", category: "Frontend" },
  { iconClass: "devicon-tanstack-query-original colored", name: "Tanstack query", category: "Frontend" },
  { iconClass: "devicon-tailwindcss-original colored", name: "Tailwind", category: "Frontend" },
  { iconClass: "devicon-bootstrap-plain colored", name: "Bootstrap", category: "Frontend" },
  { iconClass: "devicon-antdesign-plain colored", name: "Ant Design", category: "Frontend" },
  { iconClass: "devicon-nestjs-plain colored", name: "Nest js", category: "Backend" },
  { iconClass: "devicon-express-original colored", name: "Express Ts", category: "Backend" },
  { iconClass: "devicon-postgresql-plain colored", name: "Postgresql", category: "Backend" },
  { iconClass: "devicon-prisma-plain colored", name: "Prisma", category: "Backend" },
  { iconClass: "devicon-spring-original colored", name: "Spring Boot", category: "Backend" },
  { iconClass: "devicon-laravel-plain colored", name: "Laravel", category: "Backend" },
  { iconClass: "devicon-dot-net-plain colored", name: ".NET", category: "Backend" },
  { iconClass: "devicon-socketio-original colored", name: "Socket.io", category: "Backend" },
  { iconClass: "devicon-mongodb-plain colored", name: "MongoDB", category: "Backend" },
  { iconClass: "devicon-docker-plain colored", name: "Docker", category: "DevOps" },
  { iconClass: "devicon-git-plain colored", name: "Git", category: "DevOps" },
  { iconClass: "devicon-figma-plain colored", name: "Figma", category: "UX/UI" },
];

export const Sections = {
  education: {
    title: "Education",
    qualifications: [
      {
        title: "Master's Degree in Software Engineering",
        subtitle: "Higher Institute of Computer Science and Multimedia of Sfax",
        calendar: "2022 - 2025",
      },
      {
        title: "Bachelor’s Degree in Computer Science and Multimedia",
        subtitle: "Higher Institute of Computer Science and Multimedia of Sfax",
        calendar: "2019 - 2022",
      },
      {
        title: "High School Diploma in Mathematics",
        subtitle: "Farhat Hached High School",
        calendar: "2018 - 2019",
      },
    ],
  },
  work: {
    title: "Work",
    qualifications: [
      {
        title: "Full-Stack Software Engineer (Freelance)",
        subtitle: "Smart Ways Innovation, Luxembourg/Remote",
        calendar: "Jan 2024 - Present | 1.5+ Years",
      },
      {
        title: "Full stack Laravel developer",
        subtitle: "Malcolm Technology Yazılım A.Ş., Turkey, Onsite",
        calendar: "Apr 2025 - Aug 2025 | 5 Months",
      },
      {
        title: "Full-Stack JS Developer",
        subtitle: "Astrolab Agency, Tunisia, Hybrid",
        calendar: "Aug 2024 - Dec 2024 | 5 Months",
      },
      {
        title: "Full-Stack Developer (MERN)",
        subtitle: "Converty, Tunisia, Remote",
        calendar: "May 2023 - Aug 2023 | 4 Months",
      },
      {
        title: "Full-Stack Developer & UX/UI Designer",
        subtitle: "Tekab, Tunisia, Onsite",
        calendar: "May 2022 - May 2023 | 1 Year",
      },
      {
        title: "Full stack developer & UX/UI Designer",
        subtitle: "DevIT, Tunisia, Onsite",
        calendar: "Jan 2022 - May 2022 | 5 Months | Internship",
      },
      {
        title: "Web designer",
        subtitle: "Flash dating, United State, Remote",
        calendar: "Jun 2021 - Aug 2021 | 3 Months |  Freelance",
      },
      {
        title: "UX Agile manager",
        subtitle: "UX World Academy, Tunisia, Remote",
        calendar: "Jun 2021 - Aug 2021 | 3 Months |  Internship",
      },
      {
        title: "Full stack developer",
        subtitle: "Team-Dev, Tunisia, hybrid",
        calendar: "Aug 2020 - Oct 2020 | 3 Months | Internship",
      },

    ],
  },
};
export const Projects = [
  {
    imgSrc: "projectsImg/financeapp.png",
    title: "Finance Management System",
    description:
      "A web app to manage financial transactions, subscriptions, and multi-branch operations with role-based access. Built with React, NestJS, Prisma, and PostgreSQL.",
    projectLink: "https://dar-coran.com/",
    githubLink: "",
  },
  {
    imgSrc: "projectsImg/vanlog.png",
    title: "Vanlog Tracking Platform",
    description: "Logistics tracking system featuring Atomic Design, i18n, Redux Toolkit, and real-time chat updates.",
    projectLink: "https://vanlog-express.com/",
    githubLink: "",
  },
  {
    imgSrc: "projectsImg/trackingSys.png",
    title: "Tracking System Web App",
    description:
      "A web app for project, ticket, and equipment management with real-time notifications. Built with React, Express, Prisma, and PostgreSQL.",
    projectLink: "https://github.com/shaimaHamila/Tracking_system",
    githubLink: "https://github.com/shaimaHamila/Tracking_system",
  },
  {
    imgSrc: "projectsImg/realtimeChatApp.png",
    title: "Real time chat app",
    description: "Built with React, Node.js, and Socket.io for seamless real-time messaging.",
    projectLink: "https://github.com/shaimaHamila/chat-App",
    githubLink: "https://github.com/shaimaHamila/chat-App",
  },
  {
    imgSrc: "projectsImg/hospitalManagement.png",
    title: "Hospital Management",
    description: "Hospital Management System developed with React and ASP.NET Core EF 8.",
    projectLink: "https://github.com/shaimaHamila/HospitalManagement",
    githubLink: "https://github.com/shaimaHamila/HospitalManagement",
  },
  {
    imgSrc: "projectsImg/StackOverflowClone.png",
    title: "Stack-Overflow-Clone",
    description: "StackOverflow clone built with Angular and Spring Boot, utilizing JWT for security.",
    projectLink: "https://github.com/shaimaHamila/Stack-Overflow-Clone",
    githubLink: "https://github.com/shaimaHamila/Stack-Overflow-Clone",
  },
  {
    imgSrc: "projectsImg/RunGroup.png",
    title: "RunGroup web app",
    description: "RunGroup is a Spring MVC web app designed to manage running clubs and events efficiently.",
    projectLink: "https://github.com/shaimaHamila/RunGroup",
    githubLink: "https://github.com/shaimaHamila/RunGroup",
  },
  {
    imgSrc: "projectsImg/kanbanboard.png",
    title: "Kanban Board",
    description:
      "A task management system with drag-and-drop support for organizing tasks by status. Built with Laravel and Livewire.",
    projectLink: "https://github.com/shaimaHamila/taskmanage-kanban",
    githubLink: "https://github.com/shaimaHamila/taskmanage-kanban",
  },
  {
    imgSrc: "projectsImg/movieWebsite.png",
    title: "Movie Website",
    description: "A web app to browse, search, and manage movie information. Built with React, Redux, and a mock API.",
    projectLink: "https://github.com/shaimaHamila/MovieWebsite",
    githubLink: "https://github.com/shaimaHamila/MovieWebsite",
  },
  {
    imgSrc: "projectsImg/wordpressWebsite.png",
    title: "Wordpress Website",
    description: "I designed and developed this website using WordPress.",
    projectLink: "",
  },
  {
    imgSrc: "projectsImg/UXUIDesign.png",
    title: "UX/UI Design",
    description: "I designed this Landing page.",
    projectLink: "https://dribbble.com/shots/22791979-Game-Streaming-UX-UI-design?utm_source=Clipboard_Shot&utm_campaign=shaimaHamila&utm_content=Game%20Streaming%20-%20UX%2FUI%20design&utm_medium=Social_Share&utm_source=Clipboard_Shot&utm_campaign=shaimaHamila&utm_content=Game%20Streaming%20-%20UX%2FUI%20design&utm_medium=Social_Share",
  },
  {
    imgSrc: "projectsImg/fansbookAPP.png",
    title: "Mobile App",
    description: "Developed Fansbook, a mobile app using Ionic/Angular and Firebase.",
    projectLink: "https://github.com/shaimaHamila/fansbook",
    githubLink: "https://github.com/shaimaHamila/fansbook",
  },
];
export const ContactInformation = [
  {
    icon: "uil uil-envelope",
    title: "Email",
    subtitle: "shaima@hamila.uk",
  },
  {
    icon: "uil uil-map-marker",
    title: "Location",
    subtitle: "Luxembourg",
  },
];

export const NavLinks = [
  { href: "#intro", label: "Home" },
  { href: "#about", label: "About" },
  { href: "#services", label: "Services" },
  { href: "#skills", label: "Skills" },
  { href: "#qualification", label: "Qualification" },
  { href: "#projects", label: "Projects" },
  { href: "#contact", label: "ContactMe" },
];
